import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	position: relative;
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 1rem;
`;

export const centralize = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 1.5rem;
`;

export const containerList = styled.div<{ $maxHeightList: number }>`
	position: absolute;
	top: 100%;
	width: 100%;
	max-height: ${(props) => `${props.$maxHeightList}px`};
	overflow: auto;
	display: flex;
	flex-direction: column;
	gap: 1rem;
	border-left: 1px solid ${color.interface.lightGray2};
	border-right: 1px solid ${color.interface.lightGray2};
	border-bottom: 1px solid ${color.interface.lightGray2};
	border-top: none;
	border-bottom-left-radius: 5px;
	border-bottom-right-radius: 5px;
	background-color: ${color.interface.white};
	z-index: 100;
`;

export const itemList = styled.div`
	position: relative;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 1rem;
	padding: 1rem;
	cursor: pointer;
	border-radius: 5px;

	> p {
		font-size: 1.3rem;
		color: ${color.interface.lightGray};
	}

	> svg {
		width: 3rem;
		height: 3rem;
		color: ${color.interface.lightGray};
	}
`;

export const unselect = styled.div`
	position: absolute;
	top: 50%;
	right: 0;
	transform: translate(-10%, -10%);
	background-color: white;
	cursor: pointer;

	> svg {
		width: 3rem;
		height: 3rem;
		color: ${color.interface.lightGray};
	}
`;
